import type { JSONSchema7 } from 'json-schema';

import type * as api from '@gitbook/api-client';

import siteVisitorMetaSchema from './meta-schemas/site-adaptive-json-schema-meta-schema.json';
import siteVisitorWithRegionsMetaSchema from './meta-schemas/site-adaptive-json-schema-with-regions-meta-schema.json';

export const SITE_VISITOR_JSON_SCHEMA_META_SCHEMA = siteVisitorMetaSchema;

/** Meta schema of site visitor schemas that can declare `regions`, for organizations with regions enabled. */
export const SITE_VISITOR_JSON_SCHEMA_WITH_REGIONS_META_SCHEMA = siteVisitorWithRegionsMetaSchema;

export const DEFAULT_SITE_ADAPTIVE_SCHEMA: api.SiteAdaptiveJSONSchema = {
    type: 'object',
    properties: {
        isLoggedIn: {
            type: 'boolean',
            description: 'Whether the user is logged in to the application.',
        },
        isBetaUser: {
            type: 'boolean',
            description: 'Whether the user is a beta user.',
        },
        plan: {
            type: 'string',
            description: `The user's current subscription plan.`,
            enum: ['free', 'plus', 'enterprise'],
        },
        unsigned: {
            type: 'object',
            description: 'Unsigned claims of the site visitor.',
            properties: {
                programmingLanguage: {
                    type: 'string',
                    description: 'The preferred programming language of the visitor',
                    enum: ['python', 'javascript', 'java', 'go'],
                },
            },
            additionalProperties: false,
        },
    },
    additionalProperties: false,
} as const;

export const EMPTY_JSON_SCHEMA: JSONSchema7 = {
    type: 'object',
    properties: {},
    additionalProperties: false,
};

export * from './claims';
export * from './schemas';
